import React from 'react';
import ReactDOM from 'react-dom';

import {GoogleMap} from '/components/google-map/components';
(() => {
    const googleMaps = document.querySelectorAll('[data-google-map]');
    googleMaps.forEach((googleMap) => {
        ReactDOM.render(
            <GoogleMap
                address={+googleMap.dataset.address}
                latitude={+googleMap.dataset.latitude}
                longitude={+googleMap.dataset.longitude}
                pins={getPins(googleMap.dataset.pins)}
            />,
            googleMap,
        );
    });
})();
function getPins(pins){
    var items=JSON.parse(pins);
    var rows = [];
    for (const [key, value] of Object.entries(items)) {
        rows.push(value);
    }
    return rows;
}
